import React from "react";
import { Network, GitBranch, CornerDownRight, CornerUpLeft } from "lucide-react";

export const DependencyViewControls = ({
  viewMode,
  onViewModeChange,
  renderType,
  onRenderTypeChange,
  compact = true,
}) => {
  const buttonPadding = compact ? "py-1" : "py-1.5";
  return (
    <div className="flex flex-wrap items-center gap-4">
      {/* View Type Group */}
      <div className="flex items-center gap-2">
        <span className="text-xs font-medium text-gray-700 uppercase tracking-wide">View</span>
        <div className="inline-flex items-center rounded-full bg-blue-50 border border-blue-200 p-1">
          <button
            onClick={() => onViewModeChange?.("network")}
            className={`px-3 ${buttonPadding} text-xs font-semibold rounded-full transition-colors whitespace-nowrap flex items-center gap-1 ${
              viewMode === "network"
                ? "bg-blue-600 text-white shadow-sm border border-blue-700"
                : "text-slate-600 border border-transparent hover:text-slate-800 hover:border-slate-200"
            }`}
          >
            <Network size={14} />
            Network
          </button>
          <button
            onClick={() => onViewModeChange?.("tree")}
            className={`px-3 ${buttonPadding} text-xs font-semibold rounded-full transition-colors whitespace-nowrap flex items-center gap-1 ${
              viewMode === "tree"
                ? "bg-blue-600 text-white shadow-sm border border-blue-700"
                : "text-slate-600 border border-transparent hover:text-slate-800 hover:border-slate-200"
            }`}
          >
            <GitBranch size={14} />
            Tree
          </button>
        </div>
      </div>

      {/* Vertical Divider */}
      <div className="h-6 w-px bg-slate-300"></div>

      {/* Direction Group */}
      <div className="flex items-center gap-2">
        <span className="text-xs font-medium text-gray-700 uppercase tracking-wide">Direction</span>
        <div className="inline-flex items-center rounded-full bg-blue-50 border border-blue-200 p-1">
          <button
            onClick={() => onRenderTypeChange?.("downstream")}
            className={`px-3 ${buttonPadding} text-xs font-semibold rounded-full transition-colors flex items-center gap-1 ${
              renderType === "downstream"
                ? "bg-blue-600 text-white shadow-sm border border-blue-700"
                : "text-slate-600 border border-transparent hover:text-slate-800 hover:border-slate-200"
            }`}
          >
            <CornerDownRight size={14} />
            Downstream
          </button>
          <button
            onClick={() => onRenderTypeChange?.("upstream")}
            className={`px-3 ${buttonPadding} text-xs font-semibold rounded-full transition-colors flex items-center gap-1 ${
              renderType === "upstream"
                ? "bg-blue-600 text-white shadow-sm border border-blue-700"
                : "text-slate-600 border border-transparent hover:text-slate-800 hover:border-slate-200"
            }`}
          >
            <CornerUpLeft size={14} />
            Upstream
          </button>
        </div>
      </div>
    </div>
  );
};
